import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'lfx-meeting-not-found',
  templateUrl: './meeting-not-found.component.html',
  styleUrls: ['./meeting-not-found.component.scss'],
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
})
export class MeetingNotFoundComponent {}
